// import { todaysDateFormatted } from '@/utilities/dateUtilities'
import msalApi from "../config/setupMSALAxios"; // your configured Axios instance

export const searchForPatient = (searchTerm) => msalApi.get(`/api/Patient/Search?search=${searchTerm}`).then((response) => response.data);
export const fetchPatientDXCodes = (personId, assessmentId) => msalApi.get(`/api/Patient/GetDXCodeRecords?personId=${personId}&assessmentId=${assessmentId}`).then((response) => response.data);

export const fetchAssessmentDXHistory = (personalDXCodeId, assessmentId) =>
  msalApi.get(`/api/Patient/GetAssessmentDXHistory?personalDXCodeId=${personalDXCodeId}&assessmentId=${assessmentId}`).then((response) => response.data);
export const deleteDXAssessmentDetail = (personalDXCodeId, assessmentId) =>
  msalApi.delete(`/api/Patient/DeleteDXAssessmentDetail?personalDXCodeId=${personalDXCodeId}&assessmentId=${assessmentId}`).then((response) => response.data);

export const fetchPatientById = (personId) => msalApi.get(`/api/Patient/GetPersonDemographics?personId=${personId}`).then((response) => response.data);

// &^ Appointments
export const fetchAppointments = () => msalApi.get(`/api/Scheduler/GetAppointments`).then((response) => response.data);

// &^ 08/07/2025 New
export const fetchPatientListFromSchedule = () => msalApi.get(`/api/Patient/GetPatientListFromSchedule`).then((response) => response.data);
export const fetchPatientMasterList = () => msalApi.get(`/api/Patient/GetPatientMasterList`).then((response) => response.data);

// del 08/07/2025     TODO
export const fetchTodaysPatientList = () => msalApi.get(`/api/Patient/GetTodaysPatientList`).then((response) => response.data);
export const fetchTodaysPatientListFromArray = (patientList) => msalApi.get(`/api/Patient/GetTodaysPatientListFromArray?patientList=${patientList}`).then((response) => response.data);

export const deleteDXRecordComment = (noteId) => {
  return msalApi
    .delete("/api/Patient/DeleteDiagnosisComment", {
      params: {
        personalDXCodeNoteId: noteId,
      },
    })
    .then((response) => response.data);
};

export const editDXRecordComment = (personalDXCodeNoteId, personalDXCodeId, commentText) => {
  // console.log()
  // console.log('   PATIIENT API   editDXRecordComment')
  // console.log('personalDXCodeNoteId')

  // console.log(personalDXCodeNoteId)
  // console.log('   TO POST ')
  // console.log(personalDXCodeNoteId.noteId)
  // console.log(personalDXCodeNoteId.personalDXCodeId)
  // console.log(personalDXCodeNoteId.editText)

  // console.log()
  return msalApi
    .post("/api/Patient/EditDiagnosisComment", {
      personalDXCodeNoteId,
      personalDXCodeId,
      commentText,
    })
    .then((response) => response.data);
};
export const replyDXRecordComment = (parentPersonalDXCodeNoteId, personalDXCodeId, commentText) => {
  return msalApi
    .post("/api/Patient/PostNewDiagnosisComment", {
      parentPersonalDXCodeNoteId,
      personalDXCodeId,
      commentText,
    })
    .then((response) => response.data);
};

export const postNewCommentToDXRecord = (commentText, validationStatus, personalDXCodeId, codingProblemRecord) => {
  return msalApi
    .post("/api/Patient/PostNewDiagnosisComment", {
      commentText,
      validationStatus,
      personalDXCodeId,
      codingProblemRecord,
    })
    .then((response) => response.data);
};

export const setRecordRedundant = (toggleRedundantRequest) => {
  return msalApi.post("/api/Patient/SetRecordRedundant", toggleRedundantRequest).then((response) => {
    // console.log('DXRecTBL   setRecordRedundant toggleRedundantRequest')
    // console.log(' RESp: ')
    // console.log(response.data)
    response.data;
  });
};

export function todaysDateFormatted() {
  let date = new Date();
  return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`;
}

export const generatePDF = (personId, worklistId, personName) => {
  msalApi({
    url: `/api/HCC/GeneratePDF?personId=${personId}&worklistId=${worklistId}`,
    method: "GET",
    responseType: "blob", // important
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${personName}-${todaysDateFormatted()}.pdf`);
    document.body.appendChild(link);
    link.click();
  });
};

export const chartReviewed = ({ personId, comment }) => {
  return msalApi
    .post("/api/Patient/ChartReviewed", {
      personId,
      comment,
    })
    .then((response) => response.data);
};

export const postDXNewAssessment = (payload) => {
  // console.log(" postDXNewAssessment                 payload")
  // console.log(payload)
  return msalApi
    .post("/api/Patient/PostAssessment", {
      personId: payload.patientId,
      assessmentClinician: payload.assessmentClinicians,
      assessmentType: payload.assessmentTypes,
      assessmentLocation: payload.assessmentLocations,
      assessmentSchedule: payload.assessmentScheduledAppointments,
    })
    .then((response) => response.data);
};

export const postDXAssessmentDetail = (incPayload) => {
  // console.log("payload")
  // console.log(incPayload)
  return msalApi
    .post("/api/Patient/PostDXAssessmentDetail", {
      PersonalDXCodeId: incPayload.PersonalDXCodeId,
      AssessmentId: incPayload.AssessmentId,
      Interview: incPayload.Interview,
      Exam: incPayload.Exam,
      Assessment: incPayload.Assessment,
      Decide: incPayload.Decide,
    })
    .then((response) => response.data);
};

export const fetchPatientPrescriptions = async (personId) => msalApi.get(`/api/Patient/GetPatientMedications?personId=${personId}`).then((response) => response.data);
export const fetchPatientAllergies = async (personId) => msalApi.get(`/api/Patient/GetPatientAllergies?personId=${personId}`).then((response) => response.data);
export const fetchPatientMedicationMappings = async (personId) => msalApi.get(`/api/HCC/GetPatientMedicationMapping?personId=${personId}`).then((response) => response.data);
export const fetchDiscreteDataMapping = async (personalDxCodeId, discreteDataMappingType) =>
  msalApi.get(`/api/Patient/GetDiscreteDataMapping?personalDxCodeId=${personalDxCodeId}&discreteDataMappingType=${discreteDataMappingType}`).then((response) => response.data);

export const fetchRelevantDiscreteData = async (personalDxCodeId) => msalApi.get(`/api/Patient/GetRelevantDiscreteData?personalDxCodeId=${personalDxCodeId}`).then((response) => response.data);

export const postDiscreteDataMapping = (personalDXCodeId, discreteDataType, discreteDataKeys) => {
  return msalApi
    .post("/api/Patient/PostDiscreteDataMapping", {
      personalDXCodeId,
      discreteDataType,
      discreteDataKeys,
    })
    .then((response) => response.data);
};

export const postMedToDxCodeMapping = (personId, rxNormCode, dxCodes) => {
  return msalApi
    .post("/api/HCC/PostMedToDxCodeMapping", {
      personId,
      rxNormCode,
      dxCodes,
    })
    .then((response) => response.data);
};

// TODO post put patient vitals
export const postPatientVitals = (incPayload) => {
  console.log("postPatientVitals :     ");
  console.log(incPayload);

  const postVitals = {
    personId: incPayload.personId,
    id: incPayload.id,
    weight: incPayload.weight,
    height: incPayload.height,
    temperature: incPayload.temperature,
    temperatureMethod: incPayload.temperatureMethod,
    pulseRate: incPayload.pulseRate,
    pulsePattern: incPayload.pulsePattern,
    bpSystolic: incPayload.bpSystolic,
    bpDistolic: incPayload.bpDistolic,
    bpPosition: incPayload.bpPosition,
    bpCuffLocation: incPayload.bpCuffLocation,
    bpCuffSize: incPayload.bpCuffSize,
    respirationRate: incPayload.respirationRate,
    respirationPattern: incPayload.respirationPattern,
    o2Saturation: incPayload.o2Saturation,
    peakFlow: incPayload.peakFlow,
    painLevel: incPayload.painLevel,
    comments: incPayload.comments,
  };

  console.log(" postVitals :     ");
  console.log(postVitals);

  return msalApi.post("/api/Patient/PostPatientVitalsData", postVitals).then((response) => response.data);
};
export const putPatientVitals = (incPayload) => {
  console.log("putPatientVitals :     ");
  console.log(incPayload);

  const putVitals = {
    personId: incPayload.personId,
    id: incPayload.id,
    collectionDateTime: incPayload.collectionDateTime,
    weight: incPayload.weight,
    height: incPayload.height,
    temperature: incPayload.temperature,
    temperatureMethod: incPayload.temperatureMethod,
    pulseRate: incPayload.pulseRate,
    pulsePattern: incPayload.pulsePattern,
    bpSystolic: incPayload.bpSystolic,
    bpDistolic: incPayload.bpDistolic,
    bpPosition: incPayload.bpPosition,
    bpCuffLocation: incPayload.bpCuffLocation,
    bpCuffSize: incPayload.bpCuffSize,
    bpPalpated: incPayload.bpPalpated,
    respirationRate: incPayload.respirationRate,
    respirationPattern: incPayload.respirationPattern,
    o2Saturation: incPayload.o2Saturation,
    peakFlow: incPayload.peakFlow,
    bmi: incPayload.bmi,
    painLevel: incPayload.painLevel,
    bsa: incPayload.bsa,
    comments: incPayload.comments,
  };

  console.log(" putVitals :     ");
  console.log(putVitals);

  return msalApi.put("/api/Patient/PutPatientVitalsData", putVitals).then((response) => response.data);
};
